import { ComponentPropsWithoutRef } from 'react';

export default function ArrowDownCrossed(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg
      {...props}
      version="1.1"
      viewBox="0 0 13 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        d="m1.12 6.38 4.97 4.62m4.97-4.62-2.03 1.89m-2.94 2.73 3.95-3.68m-3.95 3.68 1.2e-4 -9.12m-1.2e-4 -0.881v4.53m-4.87-4.53 4.87 4.53m5.8 5.4-2.86-2.67m-6e-5 -3e-5 -2.94-2.73"
      />
    </svg>
  );
}
